import { render, staticRenderFns } from "./EvidencePreviousComment.vue?vue&type=template&id=0b543c4d&scoped=true"
import script from "./EvidencePreviousComment.vue?vue&type=script&lang=js"
export * from "./EvidencePreviousComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b543c4d",
  null
  
)

export default component.exports